import { Path, Rect, Svg, SvgProps } from 'react-native-svg'

export default function TrFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Rect width="60" height="40" fill="#C8102E" />
      <Path
        d="M27.8334 20L36.8787 17.0613L31.288 24.7553V15.2447L36.8787 22.9387L27.8334 20ZM28.45 25.3473C27.2915 27.1782 25.5696 28.5832 23.5436 29.351C21.5176 30.1188 19.2971 30.2079 17.2161 29.6047C15.1352 29.0016 13.3063 27.739 12.0049 26.0068C10.7035 24.2746 9.99982 22.1666 9.99982 20C9.99982 17.8334 10.7035 15.7254 12.0049 13.9932C13.3063 12.261 15.1352 10.9984 17.2161 10.3953C19.2971 9.79214 21.5176 9.88119 23.5436 10.649C25.5696 11.4168 27.2915 12.8218 28.45 14.6527C27.3681 13.4488 25.9465 12.6014 24.3729 12.2224C22.7993 11.8434 21.1477 11.9507 19.6364 12.53C18.125 13.1093 16.8249 14.1335 15.9078 15.4672C14.9907 16.8009 14.4997 18.3814 14.4997 20C14.4997 21.6186 14.9907 23.1991 15.9078 24.5328C16.8249 25.8665 18.125 26.8907 19.6364 27.47C21.1477 28.0494 22.7993 28.1566 24.3729 27.7776C25.9465 27.3986 27.3681 26.5512 28.45 25.3473Z"
        fill="#ffffff"
      />
    </Svg>
  )
}
